import { CLEANLINESS_SCORE_BANDS } from '../../global/constants/cleanliness'

type CleanlinessBand = 'clean' | 'watch' | 'poor' | 'none'

const CLEANLINESS_BAND_LABELS: { [band in CleanlinessBand]: string } = {
  clean: 'Clean',
  watch: 'Watch',
  poor: 'Needs attention',
  none: 'No score',
}

// Bands are judged on the whole number the page displays, so a chip that
// reads "85" is never colored as if it were 84.75.
function getCleanlinessBand(score: number | null): CleanlinessBand {
  if (score === null || Number.isNaN(score)) return 'none'
  const displayed = Math.round(score)
  if (displayed >= CLEANLINESS_SCORE_BANDS.clean) return 'clean'
  if (displayed >= CLEANLINESS_SCORE_BANDS.watch) return 'watch'
  return 'poor'
}

export { type CleanlinessBand, CLEANLINESS_BAND_LABELS, getCleanlinessBand }
